// // components/CustomVideoPlayer.tsx

// import React, { FC, useRef, useState } from "react";

// type Props = {
//   videoSrc: string;
//   className?: string;
// };

// const VideoPlayer: FC<Props> = ({ videoSrc, className = "" }) => {
//   const videoRef = useRef<HTMLVideoElement | null>(null);
//   const [isPlaying, setIsPlaying] = useState(false);

//   const handlePlay = () => setIsPlaying(true);
//   const handlePause = () => setIsPlaying(false);

//   const handleCustomPlayClick = () => {
//     if (videoRef.current) {
//       if (videoRef.current.paused) {
//         videoRef.current.play();
//       } else {
//         videoRef.current.pause();
//       }
//     }
//   };

//   return (
//     <div className={`relative ${className}`}>
//       <video
//         ref={videoRef}
//         className="aspect-video h-auto w-full rounded-md object-cover shadow-lg"
//         controls
//         onPlay={handlePlay}
//         onPause={handlePause}
//       >
//         <source src={videoSrc} type="video/mp4" />
//         Your browser does not support the video tag.
//       </video>

//       {/* Custom Play Button Overlay */}
//       <div
//         onClick={handleCustomPlayClick}
//         className="absolute inset-0 z-10 flex cursor-pointer items-center justify-center"
//       >
//         {!isPlaying && (
//           <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white shadow-lg md:h-20 md:w-20 transition-transform hover:scale-105">
//             <div className="ml-1 h-0 w-0 border-b-[10px] border-l-[16px] border-t-[10px] border-b-transparent border-l-black border-t-transparent"></div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default VideoPlayer;
 

// import React, { FC, useRef, useState } from "react";

// type Props = {
//   videoSrc: string;
//   className?: string;
// };

// const VideoPlayer: FC<Props> = ({ videoSrc, className = "" }) => {
//   const videoRef = useRef<HTMLVideoElement | null>(null);
//   const [isPlaying, setIsPlaying] = useState(false);

//   const handlePlay = () => setIsPlaying(true);
//   const handlePause = () => setIsPlaying(false);

//   const handleCustomPlayClick = () => {
//     if (videoRef.current) {
//       if (videoRef.current.paused) {
//         videoRef.current.play();
//       } else {
//         videoRef.current.pause();
//       }
//     }
//   };

//   return (
//     // <div className={`relative ${className}`}>
//     //   <video
//     //     ref={videoRef}
//     //     className="aspect-video h-auto w-full rounded-md object-cover shadow-lg"
//     //     controls
//     //     onPlay={handlePlay}
//     //     onPause={handlePause}
//     //   >
//     //     <source src={videoSrc} type="video/mp4" />
//     //     Your browser does not support the video tag.
//     //   </video>
 
//     //   {!isPlaying && (
//     //     <div
//     //       onClick={handleCustomPlayClick}
//     //       className="absolute inset-0 z-10 flex cursor-pointer items-center justify-center bg-black/20"
//     //     >
//     //       <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white shadow-lg md:h-20 md:w-20 transition-transform hover:scale-105">
//     //         <div className="ml-1 h-0 w-0 border-b-[10px] border-l-[16px] border-t-[10px] border-b-transparent border-l-black border-t-transparent"></div>
//     //       </div>
//     //     </div>
//     //   )}
//     // </div>

//     <div
//   className="relative w-full flex items-center justify-center bg-black md:bg-transparent"
//   style={{
//     height: window.innerWidth < 768 ? `${(9 / 16) * window.innerWidth}px` : "auto",
//   }}
// >
//   <video
//     ref={videoRef}
//     className="w-full h-full object-contain"
//     controls
//     onPlay={handlePlay}
//     onPause={handlePause}
//   >
//     <source src={videoSrc} type="video/mp4" />
//     Your browser does not support the video tag.
//   </video>

//   {!isPlaying && (
//     <div
//       onClick={handleCustomPlayClick}
//       className="absolute inset-0 z-10 flex cursor-pointer items-center justify-center bg-black/20"
//     >
//       <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white shadow-lg md:h-20 md:w-20 transition-transform hover:scale-105">
//         <div className="ml-1 h-0 w-0 border-b-[10px] border-l-[16px] border-t-[10px] border-b-transparent border-l-black border-t-transparent"></div>
//       </div>
//     </div>
//   )}
// </div>

//   );
// };

// export default VideoPlayer;





import React, { FC, useEffect, useRef, useState } from "react";

type Props = {
  videoSrc: string;
  className?: string;
};

const VideoPlayer: FC<Props> = ({ videoSrc, className = "" }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);

  // Detect screen size
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Detect fullscreen
  useEffect(() => {
    const handleFullscreenChange = () => {
      const fsElement =
        document.fullscreenElement ||
        (document as any).webkitFullscreenElement ||
        (document as any).mozFullScreenElement ||
        (document as any).msFullscreenElement;

      setIsFullscreen(!!fsElement);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("MSFullscreenChange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
      document.removeEventListener("mozfullscreenchange", handleFullscreenChange);
      document.removeEventListener("MSFullscreenChange", handleFullscreenChange);
    };
  }, []);

  const handlePlay = () => setIsPlaying(true);
  const handlePause = () => setIsPlaying(false);

  const handleCustomPlayClick = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  };

  const showBlackBars = isMobile && isFullscreen;

  return (
    <div
      className={`relative flex items-center justify-center ${className} ${
        showBlackBars ? "bg-black py-[10vh]" : ""
      }`}
    >
      <video
      
        ref={videoRef}
        className={`w-full h-full ${
          isMobile ? "object-contain" : "rounded-md object-cover shadow-lg"
        }`}
        controls
        onPlay={handlePlay}
        onPause={handlePause}
      >
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Show custom play button only when paused */}
      {!isPlaying && (
        <div
          onClick={handleCustomPlayClick}
          className="absolute inset-0 z-10 flex cursor-pointer items-center justify-center bg-black/20"
        >
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white shadow-lg md:h-20 md:w-20 transition-transform hover:scale-105">
            <div className="ml-1 h-0 w-0 border-b-[10px] border-l-[16px] border-t-[10px] border-b-transparent border-l-black border-t-transparent"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoPlayer;
